// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreReorder = (client) => ({
    /**
     * `POST /store/reorder`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreReorderCreate
     * @source apps/backend/src/api/store/reorder/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/reorder", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=reorder.js.map